import { ConnectionNames } from "../../../Contracts";
import { applyRESTQueries } from "../../../Common";
export function applyCaptorQueries(message) {
    return applyRESTQueries(ConnectionNames.captor, message);
}
//# sourceMappingURL=ApplyCaptorQueries.js.map